import React from "react";
import axios from "axios";
import "../App.css";
import userImg from "../assets/img/user.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { Card } from "react-bootstrap";
import { Image } from "rebass";
import Loader from "react-loader-spinner";
import tick from "../assets/img/tick.png";
import failed from "../assets/img/error.png";

class ResetPassword extends React.Component {
  componentDidMount() {
    this.setState({ isLoading: true });
    var userToken = this.props.match.params.userToken;

    this.setState({ uToken: userToken });
    this.getUser(userToken).then((res) => {
      if (res === 200) {
        this.setState({ isLoading: false });
      } else {
        return alert("Imeshindikana, Tafadhali jaribu tena.");
      }
    });
  }
  state = {
    user: null,
    password: null,
    confirmedPassword: null,
    isLoading: false,
    isVerified: false,
    uToken: null,
  };

  getUser = async (token) => {
    try {
      const user = await axios.get("https://tmw.deonhub.tz/api/user/me", {
        headers: {
          Authorization: `Basic ${token}`,
        },
      });
      if (user.status === 200) {
        this.setState({ user: user.data });
        return 200;
      }
      return 404;
    } catch (error) {
      console.log(error);
      return 400;
    }
  };

  changePassword = async () => {
    const { password, confirmedPassword } = this.state;
    try {
      if (!password || !confirmedPassword) {
        return alert("Jaza nafasi zote");
      }
      if (password !== confirmedPassword) {
        return alert("Passwords hazifanani, Hakikisha vizuri");
      }
      this.setState({ isLoading: true });
      const feedback = await axios.put(
        "https://tmw.deonhub.tz/api/user/password",
        { password: password },
        {
          headers: {
            Authorization: `Basic ${this.state.uToken}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      if (feedback.status === 200) {
        return this.setState({ isVerified: true, isLoading: false });
      }
      this.setState({ isLoading: false });
      alert("Tafadhali jaribu tena badae");
    } catch (error) {
      console.log(error);
      this.setState({ isLoading: false });
      alert("Hakikisha password ni zaidi ya herufi 5");
    }
  };

  render() {
    const { user, isLoading, isVerified } = this.state;
    return (
      <div style={{ marginTop: 50, marginLeft: 10, marginRight: 10 }}>
        <Loader
          visible={isLoading}
          type="Oval"
          color="orange"
          height={40}
          width={40}
        />

        {user && !isVerified ? (
          <div className="forgot">
            <div>
              <h3 style={{ fontWeight: "bold" }}>Badili Password</h3>
              <Card
                style={{
                  width: "100%",
                  paddingLeft: 20,
                  paddingRight: 20,
                  marginTop: 20,
                  marginBottom: 20,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Card.Img
                    variant="top"
                    src={userImg}
                    style={{ height: 60, width: 60 }}
                  />
                  <Card.Body>
                    <Card.Title>Karibu {user.firstName}</Card.Title>
                    <Card.Text style={{ color: "orange" }}>
                      {user.email}
                    </Card.Text>
                  </Card.Body>
                </div>
              </Card>
              <div className="form-group">
                <label>New Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter password"
                  onChange={(e) => this.setState({ password: e.target.value })}
                />
              </div>

              <div className="form-group" style={{ marginTop: 10 }}>
                <label>Confirm Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter password"
                  onChange={(e) =>
                    this.setState({ confirmedPassword: e.target.value })
                  }
                />
              </div>

              <button
                className="btn btn-warning btn-block"
                onClick={() => this.changePassword()}
              >
                Submit
              </button>
            </div>
          </div>
        ) : null}

        {isVerified && isLoading === false ? (
          <div
            style={{
              marginTop: 10,
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Image
              src={tick}
              sx={{
                width: ["30%"],
              }}
            />
            <p style={{ fontWeight: "bold", fontSize: 30 }}>
              Umefanikiwa Kubadili Password
            </p>
          </div>
        ) : null}
      </div>
    );
  }
}

export default ResetPassword;
